import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';
import CommonListe from '../../Common/CommonListe';
import { deleteSousModule, ISousModule, setObjSousModule, setOpenDialog, setSousModulesByModule, setValueComboEdit, setValueEdit } from './sousModuleSlice';




const ListeSousModule = () => {


    //redux
    const dispatch = useDispatch()
    const { objModule } = useSelector((state: IReduxState) => state.module);
    const { sousModules, sousModulesByModule } = useSelector((state: IReduxState) => state.sousModule);



    const deleteItem = async (item: any) => {
        try {
            const apiPayload = { idSousModule: item.idSousModule }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/route", apiPayload)
            if (res.status === 1) {
                dispatch(deleteSousModule(res.data))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };




    const getSousModuleByModule = () => {
        dispatch(setSousModulesByModule(sousModules.filter((sousModule: ISousModule) => sousModule.idModule === objModule.idModule)))
    }
    useEffect(() => {
        getSousModuleByModule()
    }, [objModule, sousModules]);


    const handleEditDialogOpen = (item: ISousModule) => {
        dispatch(setOpenDialog(true))
        dispatch(setObjSousModule(item))
        dispatch(setValueEdit(item.libelleSousModule))
        dispatch(setValueComboEdit(item.idSousModule))
    }

    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <CommonListe
                data={sousModulesByModule}
                deleteItem={deleteItem}
                setItem={setObjSousModule}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box>
    );
}

export default ListeSousModule;
